import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setPermissionError, setPermissionLoading } from "../../repository/slice";
import { getRoleById } from "../../../role/useCases/getRoleById/action";

function* deleteRolePermissionWorker({ payload }: any): SagaIterator {
    try {
        yield put(setPermissionLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.post, "/api/role-permission/delete", payload);
        if (isError) {
            yield put(setPermissionError(message));
            yield put(getRoleById({ id: payload?.role_id }));
        }
    } catch (error) {
        console.error("deleteRolePermissionWorker: ", error);
    } finally {
        yield put(setPermissionLoading(false));
    };
};

export function* deleteRolePermissionWatcher() {
    yield takeLatest("@saga/DELETE_ROLE_PERMISSION", deleteRolePermissionWorker);
};